import "../../../scss/_expand.scss"

function getSize(size) {
    if (!size) {
        return 0;
    }
    const index = size.indexOf('px');
    if (index === -1) {
        return 0;
    }
    return Number(size.substring(0, index));
}

export default {
    name: 'bs-expand-transition',
    methods: {
        beforeEnter(el) {
            el.dataset.oldPaddingTop    = el.style.paddingTop;
            el.dataset.oldPaddingBottom = el.style.paddingBottom;
            el.dataset.oldOverflow      = el.style.overflow;
            el.style.paddingTop         = '0';
            el.style.paddingBottom      = '0';
            el.style.height             = '0';
        },
        enter(el) {
            el.style.display       = 'block';
            el.style.overflow      = 'hidden';
            el.style.height        = el.scrollHeight + getSize(el.dataset.oldPaddingTop) +
                getSize(el.dataset.oldPaddingBottom) + 'px';
            el.style.paddingTop    = el.dataset.oldPaddingTop;
            el.style.paddingBottom = el.dataset.oldPaddingBottom;
        },
        afterEnter(el) {
            el.style.display       = '';
            el.style.height        = '';
            el.style.overflow      = el.dataset.oldOverflow;
            el.style.paddingTop    = el.dataset.oldPaddingTop;
            el.style.paddingBottom = el.dataset.oldPaddingBottom;
        },
        beforeLeave(el) {
            el.dataset.oldPaddingTop    = el.style.paddingTop;
            el.dataset.oldPaddingBottom = el.style.paddingBottom;
            el.dataset.oldOverflow      = el.style.overflow;

            el.style.display = 'block';
            if (el.scrollHeight !== 0) {
                el.style.height = el.scrollHeight + 'px';
            }
            el.style.overflow = 'hidden';
        },
        leave(el) {
            if (el.scrollHeight !== 0) {
                setTimeout(() => {
                    el.style.height        = 0;
                    el.style.paddingTop    = 0;
                    el.style.paddingBottom = 0;
                });
            }
        },
        afterLeave(el) {
            el.style.display       = 'none';
            el.style.height        = '';
            el.style.overflow      = el.dataset.oldOverflow;
            el.style.paddingTop    = el.dataset.oldPaddingTop;
            el.style.paddingBottom = el.dataset.oldPaddingBottom;
        }
    },
    render(h) {
        return h('transition', {
            props: {
                name: 'expand'
            },
            on: {
                'before-enter': this.beforeEnter,
                'enter': this.enter,
                'after-enter': this.afterEnter,
                'before-leave': this.beforeLeave,
                'leave': this.leave,
                'after-leave': this.afterLeave
            }
        }, this.$slots.default);
    }
};
